import type { TFunction } from "i18next";
import { systemTimezone, timezoneOffset } from "./schedule-dates";

export function timezoneLabel(zone: string, date: Date, t: TFunction) {
  const names: Record<string, string> = {
    "America/New_York": t("timezone.usEastern"),
    "America/Chicago": t("timezone.usCentral"),
    "America/Denver": t("timezone.usMountain"),
    "America/Los_Angeles": t("timezone.usPacific"),
    "America/Anchorage": t("timezone.usAlaska"),
    "Pacific/Honolulu": t("timezone.usHawaii"),
    "Asia/Taipei": t("timezone.taiwan"),
  };

  const values = { offset: timezoneOffset(zone, date), timezone: names[zone] ?? zone };
  return zone === systemTimezone
    ? t("period.currentTimezone", values)
    : t("period.namedTimezone", values);
}
